

























import { Vue, Component, Prop } from 'vue-property-decorator';
import { MutationPayload } from 'vuex';
import HttpErrorHandler from './http-error.handler';

@Component
export default class SnackbarComponent extends Vue {
  @Prop() closeIcon?: string;

  snackbar = false;

  messages: string[] = [];

  success: boolean = false;

  created() {
    this.$store.subscribe((mutation, state) => this.handleSnackbar(mutation, state));
  }

  private handleSnackbar(mutation: MutationPayload, state: any) {
    const handle = this.factory(mutation.type);
    if (handle) {
      handle(mutation.payload);
      this.snackbar = true;
    }
  }

  private factory(type: string) {
    if (type === 'snackbarState/showError') {
      return this.handleSimpleError;
    }
    if (type === 'snackbarState/handleHttpError') {
      return this.handleHttpError;
    }
    if (type === 'snackbarState/showSuccess') {
      return this.handleSucces;
    }
    return null;
  }

  private handleSimpleError(error: any) {
    this.resetSnackbar();
    this.messages = [];
    this.messages.push(error);
  }

  private handleHttpError(error: any) {
    this.resetSnackbar();
    this.messages = HttpErrorHandler.apply(error);
  }

  private handleSucces(message: any) {
    this.messages = [];
    this.messages.push(message);
    this.success = true;
  }

  private resetSnackbar() {
    this.messages = [];
    this.success = false;
    this.snackbar = false;
  }
}

export { SnackbarComponent as VbSnackbarComponent };
